import React from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';

import styles from './nav_input.module.scss';

const NavInput = ({ to, children }) => {
  return (
    <NavLink to={to} className={styles.container}>
      <h3>{children}</h3>
      <div className={styles.halfarrow} />
    </NavLink>
  );
};

NavInput.propTypes = {
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};

export default NavInput;
